module.exports = __webpack_public_path__ + "img/alu_2.d36e1667.webp";